import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    heading: "1. Overview",
    body: [
      "ChannelHQ (\"we\", \"us\", \"the Service\") provides a workspace for creators to organize and track video production across multiple channels. This Privacy Policy explains what information we collect and how we use it.",
      "By using ChannelHQ you agree to the practices described here. This is a demo product and this policy is provided as generic boilerplate.",
    ],
  },
  {
    heading: "2. Information We Collect",
    body: [
      "Account information: your email address and password (stored securely as a salted hash) when you create a workspace.",
      "Content you create: channels, pipeline cards, notes, scripts, and performance entries you add to your workspace.",
      "Usage data: basic technical information such as browser type and timestamps, used to keep the Service reliable and secure.",
    ],
  },
  {
    heading: "3. How We Use Your Information",
    body: [
      "We use your information to operate the Service, authenticate your account, store your workspace data, and generate AI script drafts you explicitly request.",
      "We do not sell your personal information. Content you submit for AI drafting is sent to our language-model provider solely to generate the requested output.",
    ],
  },
  {
    heading: "4. Data Retention & Security",
    body: [
      "Your workspace data is retained for as long as your account is active. You may delete channels, cards, and entries at any time.",
      "We apply reasonable technical safeguards to protect your data, though no method of transmission or storage is completely secure.",
    ],
  },
  {
    heading: "5. Contact",
    body: [
      "If you have questions about this Privacy Policy or your data, contact us at support@channelhq.app.",
    ],
  },
];

export default function Privacy() {
  return <LegalPage title="Privacy Policy" updated="June 1, 2026" sections={SECTIONS} />;
}
